import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import * as dd from 'dingtalk-jsapi';
import Autocomplete from './components/Autocomplete.vue';
class DataObject {
    constructor(op) {
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let DeviceRegister = class DeviceRegister extends Vue {
    constructor() {
        super();
        this.existCustomerName = [];
        this.existOrderNumberList = [];
        this.searchOptions = {
            deviceType: '',
            quickly: '',
            bindingType: 0,
            erpOrderNoId: '',
            erpOrderNo: '',
            customerName: '',
            orderType: '',
            outboundOrderId: '',
            address: '' // 地点
        };
        this.orderTypeList = [];
        this.addselectDevices = [];
        this.formDeviceData = {
            devices: [],
            selectDevices: [],
        };
        this.blueCheck = false;
        this.formLoading = false;
        this.dlgSerialMgr = new CBcDialog(new CBcDialogForm());
        this.dlgSerial = new CBcDialog(new CBcDialogForm());
        // list: Array<DataObject> = []
        this.list = [];
        this.snackbar = new CBcSnackbar();
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            persistent: false,
            form: false
        };
        this.dialogLicense = {
            editor: -1,
            title: '',
            text: '',
            visible: false
        };
        this.formSubmiting = false;
        this.formValid = true;
        this.formLicense = {
            serialcode: '',
            days: '',
            deviceID: '',
            deviceType: '',
            creator: '',
            remark: '',
        };
        this.dlgResult = {
            visible: false
        };
        this.dlgPurchase = {
            visible: false,
            registerInput: false,
            registerLicense: '',
        };
        this.licenseValid = /true/i.test('<%- licenseValid %>');
        this.license = {
            code: ''
        };
        this.licenseImgUrl = '';
        this.pageLoading = false;
        this.isDevLiceUpdate = false;
        this.scanData = {}; // 扫码内容
        const that = this;
        this.formData = new DataObject({
            type: '',
            name: '',
            mode: '',
            deviceId: '',
            deviceNo: '',
            serialNumber: '',
        });
        this.currentItem = {
            type: '',
            name: '',
            deviceId: '',
            serialNumber: '',
        };
    }
    customerNameChange(value) {
        this.searchOptions.customerName = value && value.customerName || '';
    }
    selectOrderNumber(value) {
        // console.log('selectOrderNumber: ', value);
        this.searchOptions.erpOrderNoId = '';
        this.searchOptions.erpOrderNo = '';
        if (value) {
            this.searchOptions.erpOrderNo = value.orderNumber;
            if (value.type != 'input') {
                this.searchOptions.erpOrderNoId = value.id;
            }
        }
        // console.log('selectOrderNumber: ', this.searchOptions.erpOrderNoId, this.searchOptions.erpOrderNo);
    }
    get routeQuery() {
        const that = this;
        return that.$router.currentRoute.query || {};
    }
    get devLiceUpdateValue() {
        const that = this;
        return that.routeQuery.devLiceUpTxt;
    }
    get devLiceUpdateCryptType() {
        const that = this;
        return that.routeQuery.et;
    }
    get devNodeVersion() {
        const that = this;
        return that.routeQuery.v || '';
    }
    async scanBarcode() {
        // console.log('扫码...');
        const that = this;
        try {
            dd.biz.util.scan({
                type: 'all',
                onSuccess: async function (data) {
                    if (!data.text) {
                        that.snackbar.info('二维码无效，请检查');
                        return;
                    }
                    /* do something: 业务暂时不确定 */
                    // this.$emit('select', item)
                    // that.searchOptions.quickly = data.text;
                    try {
                    }
                    catch (e) {
                        that.snackbar.error('二维码内容解析错误，请联系管理员');
                    }
                },
                onFail: function (err) {
                    that.snackbar.error('扫码失败，' + err);
                }
            });
        }
        catch (e) {
            that.snackbar.error('钉钉服务请求失败:\n' + (e && e.toString()));
        }
    }
    async mounted() {
        this.orderTypeList = [{ text: '试用', value: '试用' }, { text: '销售', value: '销售' }];
        this.getDeviceInfo();
        // 客户名称中合并医院信息，因为大部分客户就是已医院为单位
        await this.axios.get('/api/hospital', {
            params: {
                simple: false,
                short: true
            }
        }).then((res) => {
            this.existCustomerName.push(...(res && res.data && res.data.result || []).map((item) => {
                return {
                    hospitalId: item.id,
                    hospitalName: item.name,
                    customerName: item.name,
                    createTime: ''
                };
            }));
        });
        await this.axios.get('/api/devCheck/receiptRecord/custom/name', {})
            .then((res) => {
            // 医院信息有的，已医院信息为主，没有的才在客户中去添加
            const queryCustomName = JSON.parse(JSON.stringify(res.data.result || []));
            queryCustomName.forEach((item) => {
                const exist = this.existCustomerName.find((existItem) => {
                    return existItem.customerName == item.customerName;
                });
                if (!exist) {
                    this.existCustomerName.push(item);
                }
            });
        })
            .catch((e) => {
            this.snackbar.error('获取客户信息出错:' + e.result + ',' + e.info + '!');
        });
        this.axios.get('/api/erp/order/outbound/order/number', { params: { limit: 50 } })
            .then((res) => {
            this.existOrderNumberList = JSON.parse(JSON.stringify(res.data.result || []));
        })
            .catch((e) => {
            this.snackbar.error('获取订单列表出错:' + e.result + ',' + e.info + '!');
        });
    }
    async created() {
    }
    getSerialList() {
        const that = this;
        that.dlgSerialMgr.loading = true;
        return that.fetchDeviceSerialList().then(() => {
            that.dlgSerialMgr.loading = false;
        }).catch((e) => {
            that.dlgSerialMgr.loading = false;
            console.log('error of get device serial: ', e);
            that.snackbar.error('获取设备机型列表出错');
        });
    }
    async linkToHosptail(hospatalName, id) {
        const that = this;
        if (id)
            that.$router.push({ name: 'HospitalInfo', params: { id: id } });
    }
    async linkToDeviceRegister() {
        const that = this;
        that.$router.push({ name: 'Register', params: {} });
    }
    // 随机生成一个用不重复16位的订单号，前三位固定为SJ-，后面13位为纯数字
    generateOrderNumber() {
        const prefix = 'SJ-';
        let suffix = '';
        // 生成13位随机数字
        for (let i = 0; i < 13; i++) {
            suffix += Math.floor(Math.random() * 10);
        }
        return prefix + suffix;
    }
    /** 设备点击事件 */
    async deviceClick() {
        const that = this;
        if (!this.searchOptions.customerName || !this.searchOptions.orderType) {
            this.snackbar.warn('请输入客户名称或订单类型');
            return;
        }
        if (!this.searchOptions.outboundOrderId && !this.searchOptions.erpOrderNo) {
            // 随机生成一个用不重复的订单号
            this.searchOptions.erpOrderNo = this.generateOrderNumber();
        }
        /** 允许先不关联设备，后续进行设备管理 */
        // if (!this.addselectDevices || !this.addselectDevices.length) {
        //   this.snackbar.warn('请先关联设备信息');
        //   return
        // }
        // 添加售后记录
        try {
            // 生成设备明细
            const detailsList = [];
            this.addselectDevices.forEach((dev) => {
                const deviceInfo = {
                    productInfoId: dev.id,
                    productName: dev.name,
                    model: dev.mode,
                    specifications: dev.specifications || '',
                    quantity: 1,
                    quantityUnit: '台',
                    remark: '',
                    receiptId: null,
                    deviceNo: dev.deviceNo,
                };
                detailsList.push(deviceInfo);
            });
            let params = {
                hospitalId: this.searchOptions.customerInfoId || null,
                hospitalName: this.searchOptions.customerName || '',
                customerInfoId: this.searchOptions.customerInfoId || null,
                customerName: this.searchOptions.customerName || '',
                userId: this.userInfo.username,
                userName: this.userInfo.userName,
                erpOrderNo: this.searchOptions.erpOrderNo || '',
                erpOrderNoId: this.searchOptions.erpOrderNoId || '',
                orderType: this.searchOptions.orderType || '',
                detailsList: detailsList,
                address: this.searchOptions.address || '',
            };
            if (this.searchOptions.customerName) {
                // 现在元数据中去查询，确认是不是医院
                const existHospital = this.existCustomerName.find((item) => item.customerName === this.searchOptions.customerName);
                if (existHospital && existHospital.hospitalId) {
                    params.hospitalId = existHospital.hospitalId;
                    params.hospitalName = existHospital.hospitalName;
                }
            }
            const result = await this.axios.post('/api/devCheck/receiptRecord', params);
            if (!result.data || !result.data.result || !result.data.result.id) {
                that.snackbar.error('新增订单售后记录失败，请联系管理员！');
                return;
            }
            that.$router.push({
                name: 'CheckFlow'
            });
        }
        catch (e) {
            that.snackbar.error(e.result + ',' + e.info + '!' || '密钥新增失败！');
            console.log('售后记录新增失败！', e?.result + ',' + e?.info + '!');
        }
    }
    editItem(item) {
        const that = this;
        if (that.$refs.refFormDevice)
            that.$refs.refFormDevice.resetValidation();
        that.dialog.persistent = false;
        that.dialog.editor = 2;
        that.dialog.title = '查看设备';
        that.dialog.text = '';
        that.formData = new DataObject(item);
        that.dialog.visible = true;
    }
    close() {
        const that = this;
        that.dialog.visible = false;
        const selectedList = this.formDeviceData.devices.filter((device) => this.formDeviceData.selectDevices.includes(device?.deviceId));
        // 合并并去重两个数组
        this.addselectDevices = [
            ...this.addselectDevices,
            ...selectedList.filter((itemB) => !this.addselectDevices.some((itemA) => itemA.deviceNo === itemB.deviceNo)),
        ];
        // 清空 this.formDeviceData.selectDevices（如果需要清空）
        this.formDeviceData.selectDevices = [];
    }
    deviceTypeCount(data) {
        // 分组并计算 quantity 的总和
        const grouped = data.reduce((acc, item) => {
            if (!acc[item.model]) {
                acc[item.model] = { quantity: 0, quantityUnit: item.quantityUnit }; // 初始化 quantity 和 type
            }
            acc[item.model].quantity += item.quantity; // 累加 quantity
            return acc;
        }, {});
        // 拼接成所需字符串
        const result = Object.entries(grouped).map(([model, item]) => {
            // 将 item 断言为包含所需属性的类型
            const { quantity, quantityUnit } = item;
            return `${model}(${quantity}${quantityUnit})`;
        }).join(', ');
        return result;
    }
    backTo() {
        const that = this;
        that.$router.push({
            name: 'CheckFlow',
            params: {
                deviceId: that.addselectDevices?.deviceId,
                deviceNo: that.addselectDevices?.deviceNo,
            }
        });
    }
    deviceFilter(item, queryText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['deviceNo'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase()));
    }
    removeItem(item) {
        this.addselectDevices = this.addselectDevices.filter((v) => v.id != item.id);
    }
    removeSelectedDevice(item) {
        const that = this;
        const index = that.formDeviceData.devices.map((v) => v.id).indexOf(item.id);
        // console.log('index: ', index)
        if (index >= 0 && (that.dialog.editor === 4))
            that.formDeviceData.devices.splice(index, 1);
    }
    addDevice() {
        const that = this;
        that.dialog.editor = 4;
        that.dialog.visible = true;
        that.dialog.form = true;
    }
    async getDeviceInfo() {
        const that = this;
        try {
            // 获取出库单信息
            const params = {
                withProducts: true,
                keyword: this.searchOptions.quickly || '医院',
            };
            const res = await that.axios.get('/api/device', { params });
            const devInfoList = res?.data?.result || [];
            // console.log('11111', JSON.stringify(devInfoList))
            this.formDeviceData.devices = devInfoList;
        }
        catch (e) {
            that.pageLoading = false;
            console.log('error of get list:', e);
            that.snackbar.error(e.info || e.errorInfo || e.result || e.error || e.toString() || '设备信息获取失败.');
        }
    }
    /** 清空 */
    clearClick() {
        this.addselectDevices = [];
    }
};
__decorate([
    Getter('deviceSerialList')
], DeviceRegister.prototype, "listSerial", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "userInfo", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "isSrvTestEnv", void 0);
__decorate([
    Action
], DeviceRegister.prototype, "fetchDevices", void 0);
__decorate([
    Action
], DeviceRegister.prototype, "fetchDeviceSerialList", void 0);
DeviceRegister = __decorate([
    Component({
        name: 'DeviceInfo',
        data: () => ({
            formRules: {
                // @ts-ignore
                days: [v => !!v || '请输入天数', v => (/^\d+$/i.test(v)) || '请输入具体天数'],
                // @ts-ignore
                notEmpty: [v => !!v || '该字段为必填项'],
            }
        }),
        components: {
            BcDialog,
            BcSnackbar,
            Autocomplete,
        }
    })
], DeviceRegister);
export default DeviceRegister;
;
